import { is_dev_default, isFunction, isThenable } from './chunk-24OWA2BQ.mjs';
import { useEffect } from 'react';

var useMount = (fn) => {
  if (is_dev_default && !isFunction(fn)) {
    console.error(
      `useMount: parameter \`fn\` expected to be a function, but got "${typeof fn}".`
    );
  }
  useEffect(() => {
    const result = fn?.();
    if (isThenable(result)) {
      return;
    }
    return result;
  }, []);
};
var use_mount_default = useMount;

export { use_mount_default };
